import { render, staticRenderFns } from "./drupal-string.vue?vue&type=template&id=01af0c2a&"
import script from "./drupal-string.vue?vue&type=script&lang=js&"
export * from "./drupal-string.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports